import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Target, Users, TrendingUp, Shield, Code } from 'lucide-react';

export function AboutPage() {
  const features = [
    {
      icon: Zap,
      title: "Lightning Fast Analysis",
      description: "Get comprehensive website copy analysis in just 11 seconds using advanced AI technology."
    },
    {
      icon: Target,
      title: "Precision Targeting",
      description: "Identify exact pain points and opportunities in your copy that directly impact conversion rates."
    },
    {
      icon: Users,
      title: "Customer-Centric",
      description: "Understand your audience better with insights based on proven psychological triggers."
    },
    {
      icon: TrendingUp,
      title: "Proven Results",
      description: "Our clients see an average of 127% increase in conversion rates after implementing our suggestions."
    },
    {
      icon: Shield,
      title: "Data Privacy",
      description: "Your website data is analyzed securely and never stored or shared with third parties."
    },
    {
      icon: Code,
      title: "Platform Agnostic",
      description: "Works with any website platform - from custom code to popular CMS solutions."
    }
  ];

  return (
    <div className="pt-32 pb-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Revolutionizing Website Copy Analysis
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            We combine artificial intelligence with years of conversion optimization expertise 
            to help businesses create compelling copy that converts.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 * index }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="bg-[#B4FF8C] w-12 h-12 rounded-xl flex items-center justify-center mb-6">
                <feature.icon className="w-6 h-6 text-black" />
              </div>
              <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="max-w-4xl mx-auto bg-black text-white rounded-3xl p-12 text-center"
        >
          <h2 className="text-3xl font-bold mb-6">Ready to Transform Your Website?</h2>
          <p className="text-lg mb-8 text-gray-300">
            Join thousands of businesses that have already improved their conversion rates 
            with our AI-powered copy analysis.
          </p>
          <button className="bg-[#B4FF8C] text-black px-8 py-3 rounded-full font-medium hover:bg-opacity-90 transition-colors">
            Start Free Analysis
          </button>
        </motion.div>
      </div>
    </div>
  );
}